import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=d6739666&"
import script from "./ProductDetail.vue?vue&type=script&lang=ts&"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports